import local from './common/polyfill';
import {createPromise} from 'fire-wind-water/spromise';
import {Piwik} from './Piwik';
import './scss/index.scss';
import {loading} from './loading';
import {skalert} from './alert';
import {sktips} from './tips';
import {thirdAnanly} from './thirdanalytics';

if (!local.smarketTemp) {
  local.smarketTemp = {};
}
let url = '';
if (window.config && window.config.api && window.config.api.gateway) {
  url = window.config.api.gateway.general || '';
}
var _piwik = new Piwik(url);
local.$s_temp = {
  change: function(s, d) {
    'use strict';
    this[s] = d;
    this.watch({type: s, data: d});
  },
  watch: function(cn) {
  },
  initPiwikSiteId: function(id) {
    _piwik.initPiwikSiteId(id);
  },
  initPiwikTenantId: function(id) {
    _piwik.initPiwikTenantId(id);
  },
  initPiwikPostUrl: function(url) {
    _piwik.initPiwikPostUrl(url);
  },
  initPiwikApiUrl: function(url) {
    _piwik.initPiwikApiUrl(url);
  },
  initMatomoUrl: function(url) {
    _piwik.initMatomoUrl(url);
  },
  initPiwik: function() {
    _piwik.setPiwik();
  },
  loading: loading,
  alert: function(html, conf) {
    skalert.show(html, conf, 0);
  },
  confirm: function(html, conf){
    skalert.show(html, conf, 1);
  },
  tips: function(s, c){
    sktips.show(s, c);
  }
};

//local.Promise = null;
createPromise();
thirdAnanly.setUrl(url);
thirdAnanly.watch();
_piwik.isTypes();
